import { POPUP_SECTIONS } from "../../constant/constant.js";

const HEADLINE_TYPES = new Set([
  POPUP_SECTIONS.TITLE,
  POPUP_SECTIONS.TEXT,
  POPUP_SECTIONS.SUBTITLE,
  POPUP_SECTIONS.PARAGRAPH,
]);

/**
 * @param {object[]} sections
 */
export function indexPostPurchaseUpsellSections(sections = []) {
  const list = Array.isArray(sections) ? sections : [];

  const findByType = (type) => {
    const index = list.findIndex((s) => s?.type === type);
    if (index < 0) return null;
    return { section: list[index], index };
  };

  const headline =
    list
      .map((section, index) => ({ section, index }))
      .find(
        ({ section }) =>
          HEADLINE_TYPES.has(section?.type) &&
          section?.type !== POPUP_SECTIONS.PRODUCT
      ) || null;

  /** @type {{ section: object, index: number, subIndex?: number, scope: string }[]} */
  const buttons = [];

  list.forEach((section, index) => {
    if (section?.type === POPUP_SECTIONS.BUTTON) {
      buttons.push({ section, index, scope: "top" });
    }
    if (section?.type === POPUP_SECTIONS.PRODUCT) {
      (section.sections || []).forEach((sub, subIndex) => {
        if (sub?.type === POPUP_SECTIONS.BUTTON) {
          buttons.push({
            section: sub,
            index,
            subIndex,
            scope: "product",
            parentSection: section,
          });
        }
      });
    }
  });

  const brandAttribution =
    findByType(POPUP_SECTIONS.BRAND_ATTRIBUTION) ||
    list
      .map((section, index) => ({ section, index }))
      .find(({ section }) => section?.setting?.role === "brandAttribution") ||
    null;

  return {
    sections: list,
    headline,
    countdown: findByType(POPUP_SECTIONS.COUNTDOWN),
    product: findByType(POPUP_SECTIONS.PRODUCT),
    brandAttribution,
    primaryCta: buttons[0] || null,
    secondaryCta: buttons[1] || null,
    buttons,
  };
}
